import { AvailableVariables } from '@gantt/components/GanttCreateOrEdit/types'

export enum JS_FUN_ARGS {
  srcObj = 'srcObj',
  restData = 'restData',
  metaData = 'metaData',
}

export const COMMON_META_DATA = {
  [JS_FUN_ARGS.metaData]: ['timezone', 'dateFormatFn', 'dateFormatInTimeZoneFn'],
}

export const HEADER_MAIN_DATA = { [JS_FUN_ARGS.srcObj]: ['field'] }

export const initialAvailableVariables = (): AvailableVariables => ({
  [JS_FUN_ARGS.srcObj]: [],
  [JS_FUN_ARGS.metaData]: [],
  [JS_FUN_ARGS.restData]: [],
})
